import RichTextsListBlock from './RichTextsListBlock';

export default RichTextsListBlock;
